const plotsScheama = [];

export default plotsScheama;
